import React, { useState, useEffect } from "react";
import { Grid, Divider, Avatar } from "@mui/material";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { FaRegDotCircle, FaRegCircle } from "react-icons/fa";
import { CiCircleQuestion } from "react-icons/ci";
import { CiCircleCheck } from "react-icons/ci";
import { FaCircle } from "react-icons/fa6";
import { GreenColorButton, DarkGreenColorButton, PrimeGrayBorderColorButton } from "../../Components/MaterialButtonStyle/StyleButton";
import CustomModal from "../../Components/Modal/CustomModal";
import { TabCustom, TabsCustom } from "../../Components/Tabs/CustomTabs";

import { GetPublicURL, PostMethod } from "../../Helper/api";
import LoaderModal from "../../Components/Modal/Loader"
import { REACT_APP_EncryptionKey } from "../../Config/config"
import CryptoJS from "crypto-js";

const CBTComponent = () => {
  const navigate = useNavigate();
  const [questions, setQuestions] = useState([]);
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [selectedOption, setSelectedOption] = useState(null);
  const [palette, setPalette] = useState([]);
  const [tabValue, setTabValue] = useState(0);

  const [instructionModal, setInstructionModal] = useState(false);
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [incompleteModal, setIncompleteModal] = useState(false);
  const [testSubmissionModal, setTestSubmissionModal] = useState(false);
  const [successModal, setSuccessModal] = useState(false);
  const [ShowLoader, setShowLoader] = useState(false)
  const [SampleQuestionsInfo, setSampleQuestionsInfo] = useState([])
  const [JobApplications, setJobApplications] = useState()
  const [applicant_image, setapplicant_image] = useState()
  const [ProfileDetails, setProfileDetails] = useState()
  const [CategorysList, setCategorysList] = useState()

  const UserID = localStorage.getItem("@userid")

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      event.preventDefault();
      event.returnValue = ""; // For older browsers
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  const HandleTabChange = (event, newValue) => {
    setTabValue(newValue);

    const filteredQuestions = SampleQuestionsInfo.filter((question) => {
      if (newValue === 0) return true;
      const categories =CategorysList //["History", "General Knowledge", "Aptitude", "Nigerian Constitution"];
      return String(question.category).trim() == categories[newValue - 1] ;

    });
    setQuestions(filteredQuestions);

  };

  const HandleOptionSelect = (option) => {
    setSelectedOption(option);
  };

  const HandleSaveAndNext = () => {
    if (selectedOption) {
      const updatedQuestions = [...questions];
      updatedQuestions[currentQuestionIndex].status = "Answered";
      updatedQuestions[currentQuestionIndex].selectedOption = selectedOption;
      setQuestions(updatedQuestions);
      UpdatePalette(currentQuestionIndex, "Answered");
    } else {
      UpdatePalette(currentQuestionIndex, "Not Answered");
    }
    MoveToNextQuestion();
  };

  const MoveToNextQuestion = () => {
    if (currentQuestionIndex < questions.length - 1) {
      setCurrentQuestionIndex((prev) => prev + 1);
      setSelectedOption(null);
    }
  };

  const UpdatePalette = (index, status) => {
    const updatedPalette = [...palette];
    updatedPalette[index].status = status;
    setPalette(updatedPalette);
  };

  const HandleQuestionClick = (index) => {
    setCurrentQuestionIndex(index);
    setSelectedOption(questions[index]?.selectedOption || null);
    if (questions[index].status === "Not Visited") {
      UpdatePalette(index, "Not Answered");
    }
  };

  const GetStatusColor = (status) => {
    if (status == "Answered") {
      return "#0FBE7C";
    }
    if (status == "Not Answered") {
      return "#1565C0";
    }
    else {
      return "#666666";
    }
  };

  const HandleSuccessModal = () => {
    setSuccessModal(false);
    navigate("/computerbasedtest");
    toast.success("Your submission has been successfully completed.");
  }
  const [remainingcount,setremainingcount] = useState(0);
  const [timeLeft, setTimeLeft] = useState(60);

  useEffect(() => {
    if (remainingcount) {
      setTimeLeft(remainingcount);
    }
  }, [remainingcount]);

  useEffect(() => {
    if (timeLeft <= 0) return;

    const timeout = setTimeout(() => {
      setTimeLeft((prevTime) => (prevTime > 0 ? prevTime - 1 : 0));
    }, 1000);

    return () => clearTimeout(timeout);
  }, [timeLeft]);

  const formatTime = (seconds) => {
    const minutes = Math.floor((seconds) / 60).toString().padStart(2, "0");

    let remainingSeconds = Math.floor(seconds % 60).toString().padStart(2, "0");

    if (remainingSeconds === "60") {
      remainingSeconds = "00";
    }

    return `${minutes}:${remainingSeconds}`;
  };


  useEffect(()=>{
    getUsersDetails()
  },[])
  function shuffleArray(array) {
    let shuffledArray = [...array]; // Create a copy to avoid mutating the original array
    for (let i = shuffledArray.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1)); // Get random index
      [shuffledArray[i], shuffledArray[j]] = [shuffledArray[j], shuffledArray[i]]; // Swap elements
    }
    return shuffledArray;
  }
  const getUsersDetails =async()=>{
    try{
      let url="test/computertestDetails"
      let method ="POST"
      let params ={
        candidate_uuid:UserID
      }
      setShowLoader(true)
      const response =await PostMethod({url,method,params})
      if(response.status){
        setJobApplications(response.result[0])
        if(response.result[0].applicant_image){
          const Images =await GetPublicURL(response.result[0].applicant_image)
          setapplicant_image(Images)
        }
        if(response.result[0]?.mcq_qustions){
          let timestamp = response.result[0].mcq_test_duration
          const [hours, minutes, seconds] = timestamp.split(":").map(Number);
          let totalMinutes = hours * 60 + minutes + seconds / 60;
          totalMinutes = totalMinutes *60
          setremainingcount(totalMinutes)
          if(response.result[0].mcq_qustions){
            let categorys =[]
            response.result[0].mcq_qustions?.map((job)=>{
              let cat = String(job.category).trim()
              categorys.push(cat)
            })
            const uniqueArray = [...new Set(categorys)];
            setCategorysList(uniqueArray)
          }
          let quess = shuffleArray(response.result[0].mcq_qustions)
          setSampleQuestionsInfo(quess)
          setPalette(quess)
          setQuestions(quess)
        }
        if(response.result[0]?.applicant_temp_details){
          let data =response.result[0].applicant_temp_details
          const formattedArray = [
            data.reduce((result, item) => {
              const sanitizedKey = item.name.replace(/\s+/g, ""); // Remove spaces from the key
              result[sanitizedKey] = item.value; // Assign the value to the sanitized key
              return result;
            }, {})
          ];
          setProfileDetails(formattedArray[0])
        }

        setShowLoader(false)
      }else{
        setShowLoader(false)
      }
    }catch(Error){
      setShowLoader(false)
      console.log("Error",Error)
    }
  }
  const SubmitQuestions = async()=>{
    try{
      let url="test/completedComputertest"
      let method ="PUT"
      let params ={
        "computer_test_id":JobApplications.computer_test_id ,
        "qus_data":questions,
        "instructions":[],
        "status":"completed",
        "test_completed_time":timeLeft,
        "test_venue": JobApplications?.computer_locations? JobApplications?.computer_locations[0]?.value:"",
        "test_date":JobApplications?.computer_test_date,
      }
      setShowLoader(true)
      const response =await PostMethod({url,method,params})
      if(response.status){
        navigate("/appliedjobs")
        setShowLoader(false)
      }else{
        setShowLoader(false)
      }
    }catch(Error){
      setShowLoader(false)
      console.log("Error",Error)
    }
  }
  const CheckCompletedQuestions = ()=>{
    if(questions){
      let ans =[]
      questions?.map((item)=>{
        if(item.selectedOption){
          ans.push(true)
        }
      })
      if(ans.length==questions.length){
        setTestSubmissionModal(true)
      }else{
        setIncompleteModal(true)
      }
    }
  }

  const Decryption = (data) => {
    if(data){
      var bytes = CryptoJS.AES.decrypt(data, REACT_APP_EncryptionKey);
      var originalText = bytes.toString(CryptoJS.enc.Utf8);
      return originalText;
    }else{
      return "---";
    }
  };

  return (
    <Grid container item lg={12} sm={12} md={12} xs={12} >
      <Grid item container lg={12} md={12} sm={12} className="bg-white borderRadius10 mt-3">
        <Grid item container lg={12} md={12} sm={12} justifyContent={"center"} alignItems={"center"} className="Bg-Prime-Green p-3" sx={{ borderTopLeftRadius: "10px", borderTopRightRadius: "10px" }}>
          <h4 className="poppinsSemiBold text-white text-center">{JobApplications?.job_name} - Computer Based Test</h4>
        </Grid>
        <Grid item container lg={12} md={12} sm={12} xs={12} className="p-3" justifyContent={"space-between"}>
          <Grid item container lg={9} md={7.9} sm={12} xs={12} className="p-3" sx={{ borderRight: "1px solid #a7aba96e" }}>
            <Grid item lg={12} sm={12} md={12} xs={12} container alignContent={"flex-start"}>
              <Grid item container lg={12} md={12} sm={12} justifyContent={"space-between"} alignItems={"center"}>
                <Grid item container lg={6} md={6} sm={12} alignItems={"center"}>
                  <p className="Text-Prime-Black poppinsMedium text-left">Categories: </p>
                </Grid>
                <Grid item container lg={6} md={6} sm={12} justifyContent={"flex-end"} alignItems={"center"}>
                  <p className="text-black poppinsMedium text-left mr-1">Time Left: </p><h4 className="text-black poppinsSemiBold text-left">{remainingcount && timeLeft ? formatTime(timeLeft) : "00:00"}</h4>
                </Grid>
              </Grid>
              <Divider className="mt-3 w-100" sx={{ border: "1px solid #a7aba96e" }} />
              <Grid item container>
                <TabsCustom value={tabValue} onChange={HandleTabChange} centered>
                  <TabCustom label="All Questions" iconPosition="end" />
                  {CategorysList?.map((cat,i)=>{
                    return(
                      <TabCustom key={i} label={cat} iconPosition="end" />
                    )
                  })}
                 
                  {/* <TabCustom label="Nigerian History" iconPosition="end" />
                  <TabCustom label="General Knowledge" iconPosition="end" />
                  <TabCustom label="Aptitude" iconPosition="end" />
                  <TabCustom label="Nigerian Constitution" iconPosition="end" /> */}
                </TabsCustom>
              </Grid>
              <Grid item container lg={12} md={12} sm={12} flexDirection={"column"} justifyContent={"center"} className="p-4">
                <p className="text-black poppinsRegular text-left mt-3">Question No: {currentQuestionIndex +1}</p>
                <Divider className="mt-3 w-100" sx={{ border: "1px solid #a7aba96e" }} />
                <p className="text-black poppinsRegular text-left mt-3">{questions[currentQuestionIndex]?.question}</p>
                {questions[currentQuestionIndex]?.options.map((option, index) => (
                  <p
                    key={index}
                    onClick={() => HandleOptionSelect(option, index)}
                    className="text-black poppinsRegular text-left mt-3 pointer"
                    role="presentation"
                  >
                    {selectedOption === option ? (
                      <FaRegDotCircle size={20} color="#0FBE7C" className="mr-2" />
                    ) : (
                      <FaRegCircle size={20} color="#666666" className="mr-2" />
                    )}
                    {option}
                  </p>
                ))}
              </Grid>
              <Grid item lg={12} sm={12} md={12} xs={12} className="pt-3" container alignContent={"flex-end"}>
                <Divider className="mt-3 w-100" sx={{ border: "1px solid #a7aba96e" }} />
                <Grid item lg={12} sm={12} md={12} xs={12} className="pt-3" container justifyContent={"flex-end"}>
                  <GreenColorButton className="px-4 py-2" onClick={HandleSaveAndNext}>Save & Next</GreenColorButton>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid item container lg={3} md={4} sm={12} xs={12} className="p-3" alignItems={"flex-start"}>
            <Grid item container lg={12} sm={12} md={12} xs={12} justifyContent={"space-between"} >
              <Grid item container lg={2} overflow={"hidden"} justifyContent={"center"} alignItems={"center"} border={"1px solid #A7ABA9"}>
                {applicant_image && <img src={applicant_image} alt="Profile-Pic" className="img-fluid" style={{ objectFit: "cover" }} />}
              </Grid>
              <Grid item container lg={9.8} flexDirection={"column"}>
                <p className="poppinsRegular text-black text-left">Name: {ProfileDetails?.Surname ? Decryption(ProfileDetails?.Surname) : ""} {ProfileDetails?.LastName ? Decryption(ProfileDetails?.LastName) : ""}</p>
                <p className="poppinsRegular text-black text-left pt-1">Registration Number: {JobApplications?.application_serial}</p>
              </Grid>
            </Grid>
            <Grid item lg={12} sm={12} md={12} xs={12} className="p-3 mt-3" sx={{ backgroundColor: "#F2F4F8", borderRadius: "4px", height: "42vh" }}>
              <Grid item lg={12}>
                <p className="poppinsRegular text-black text-left">You are viewing <span className="poppinsSemiBold">All Questions</span></p>
                <p className="poppinsSemiBold text-black text-left pt-1">Question Palette</p>
              </Grid>
              <Grid item container lg={12} justifyContent={"space-between"} sx={{ height: "30vh", overflow: "auto" }} className="CustomScroll pr-2 mt-3">
                <Grid container spacing={1}>
                  {palette.map((q, index) => (
                    <Grid item container lg={2.2} key={index} onClick={() => HandleQuestionClick(index)} justifyContent={"center"} alignItems={"center"} className="mb-2">
                      <Avatar sx={{
                        backgroundColor: GetStatusColor(q.status),
                        color: "#ffffff",
                        width: "40px",
                        height: "40px",
                        fontFamily: "PoppinsRegular",
                      }}>{index+1}</Avatar>
                    </Grid>
                  ))}
                </Grid>
              </Grid>
            </Grid>
            <Grid item lg={12} className="mt-3">
              <p className="poppinsSemiBold text-black text-left pt-1">Legend</p>
              <Divider className="my-2 w-100" sx={{ border: "1px solid #a7aba96e" }} />
              <Grid item lg={12} display={"flex"}>
                <FaCircle color={"#0FBE7C"} size={20} /><p className="poppinsRegular text-black text-left px-1">Answered</p>
                <FaCircle color={"#1565C0"} size={20} /><p className="poppinsRegular text-black text-left px-1">Not Answered</p>
                <FaCircle color={"#666666"} size={20} /><p className="poppinsRegular text-black text-left px-1">Not Visited</p>
              </Grid>
            </Grid>
            <Grid item lg={12} sm={12} md={12} xs={12} className="pt-3 d-flex" container justifyContent={"space-between"}>
              <Grid item container lg={5.8}>
                <PrimeGrayBorderColorButton className="px-3 py-2 w-100" on onClick={() => setInstructionModal(true)}>Instructions</PrimeGrayBorderColorButton>
              </Grid>
              <Grid item container lg={5.8}>
                <GreenColorButton className="px-3 py-2 w-100" onClick={() => CheckCompletedQuestions()}>Submit</GreenColorButton>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <CustomModal
        open={confirmationModal}
        setOpen={setConfirmationModal}
        divider={false}
        header={false}
        modalTitle={""}
        width={window.innerWidth > 600 ? "25%" : "95%"}
        modalContent={<Grid
          item
          container
          flexDirection={"column"}
          justifyContent={"center"}
          alignItems={"center"}
        >
          <CiCircleQuestion color={"#12A59B"} size={100} />
          <h5 className="poppinsRegular text-black pt-3 text-center">Start Test Confirmation</h5>
          <Grid item lg={12} sm={12} md={12} xs={12} className="pt-3" container flexDirection={"column"}>
            <p className="poppinsRegular text-black text-left pb-3">You are about to start the test. Please ensure you have read all the instructions carefully and are ready to begin. Once the test starts:</p>
            <ul>
              <li className="poppinsRegular text-black text-left pb-3">The timer will automatically begin counting down.</li>
              <li className="poppinsRegular text-black text-left pb-3">You cannot pause or restart the test.</li>
              <li className="poppinsRegular text-black text-left">Navigation away from the test window is not allowed.</li>
            </ul>
          </Grid>
          <Grid item container display={"flex"} justifyContent={"space-between"} sx={{ marginTop: "6%" }}>
            <Grid item container lg={5.8}>
              <PrimeGrayBorderColorButton
                className="px-3 py-2 w-100"
                onClick={() => setConfirmationModal(false)}
              >
                No
              </PrimeGrayBorderColorButton>
            </Grid>
            <Grid item container lg={5.8}>
              <DarkGreenColorButton
                className="px-3 py-2 w-100"
                onClick={() => setConfirmationModal(false)}
              >
                Yes, Start Test
              </DarkGreenColorButton>
            </Grid>
          </Grid>
        </Grid>
        }
      />
      <CustomModal
        open={instructionModal}
        setOpen={setInstructionModal}
        divider={true}
        header={true}
        modalTitle={<h4 className="poppinsMedium text-black">Instructions for Computer Based Test</h4>}
        width={window.innerWidth > 600 ? "50%" : "95%"}
        modalContent={<Grid
          item
          container
          flexDirection={"column"}
          justifyContent={"center"}
          alignItems={"center"}
        >
          <Grid item lg={12} sm={12} md={12} xs={12} className="pt-3" container flexDirection={"column"}>
            <h5 className="poppinsMedium text-black text-left">1. Read Each Question Carefully</h5>
            <p className="poppinsRegular text-black text-left pt-1">Please take your time to read each question carefully before selecting an answer. Incorrect answers may affect your score.</p>
          </Grid>
          <Grid item lg={12} sm={12} md={12} xs={12} className="pt-3" container flexDirection={"column"}>
            <h5 className="poppinsMedium text-black text-left">2. Answer All Questions</h5>
            <p className="poppinsRegular text-black text-left pt-3">You must answer all 50 questions. You cannot skip or return to previous questions once you&apos;ve moved on.</p>
          </Grid>
          <Grid item lg={12} sm={12} md={12} xs={12} className="pt-3" container flexDirection={"column"}>
            <h5 className="poppinsMedium text-black text-left">3. Time Management</h5>
            <p className="poppinsRegular text-black text-left pt-1">The test will automatically submit when the time reaches 60 minutes. Make sure to pace yourself and keep an eye on the timer.</p>
          </Grid>
          <Grid item lg={12} sm={12} md={12} xs={12} className="pt-3" container flexDirection={"column"}>
            <h5 className="poppinsMedium text-black text-left">4. No External Help</h5>
            <p className="poppinsRegular text-black text-left pt-1">Only your knowledge and memory should be used to answer the questions. External resources (e.g., textbooks, websites) are not allowed.</p>
          </Grid>
          <Grid item lg={12} sm={12} md={12} xs={12} className="pt-3" container flexDirection={"column"}>
            <h5 className="poppinsMedium text-black text-left">5. Submitting Your Test</h5>
            <p className="poppinsRegular text-black text-left pt-1">Once you have answered all the questions, you can submit your test. Ensure you&apos;re satisfied with your answers before submission.</p>
          </Grid>
          <Grid item lg={12} sm={12} md={12} xs={12} className="pt-3" container flexDirection={"column"}>
            <h5 className="poppinsMedium text-black text-left">6. Timer Activation</h5>
            <p className="poppinsRegular text-black text-left pt-1">Once you start the test, the timer will automatically start counting down. Be prepared to begin as soon as you click &quot;Start Test.&quot;</p>
          </Grid>
          <Grid item container display={"flex"} justifyContent={"flex-end"} sx={{ marginTop: "6%" }}>
            <PrimeGrayBorderColorButton
              className="px-5 py-2"
              onClick={() => setInstructionModal(false)}
            >
              Close
            </PrimeGrayBorderColorButton>
          </Grid>
        </Grid>
        }
      />
      <CustomModal
        open={incompleteModal}
        setOpen={setIncompleteModal}
        divider={false}
        header={false}
        modalTitle={""}
        width={window.innerWidth > 600 ? "25%" : "95%"}
        modalContent={<Grid
          item
          container
          flexDirection={"column"}
          justifyContent={"center"}
          alignItems={"center"}
        >
          <CiCircleQuestion color={"#12A59B"} size={100} />
          <h5 className="poppinsRegular text-black pt-3 text-center">Confirm Incomplete Submission</h5>
          <Grid item lg={12} sm={12} md={12} xs={12} className="pt-3" container flexDirection={"column"}>
            <p className="poppinsRegular text-black text-left pb-3">You are about to submit your application in its current state. Submitting incompletely means:</p>
            <ul>
              <li className="poppinsRegular text-black text-left pb-3">Your application will be submitted with the current information provided.</li>
              <li className="poppinsRegular text-black text-left pb-3">You will not be able to make further changes or complete any missing sections after submission.</li>
            </ul>
          </Grid>
          <Grid item container display={"flex"} justifyContent={"space-between"} sx={{ marginTop: "6%" }}>
            <Grid item container lg={5.8}>
              <PrimeGrayBorderColorButton
                className="px-3 py-2 w-100"
                onClick={() => setIncompleteModal(false)}
              >
                No
              </PrimeGrayBorderColorButton>
            </Grid>
            <Grid item container lg={5.8}>
              <DarkGreenColorButton
                className="px-3 py-2 w-100"
                onClick={() => { setIncompleteModal(false); setTestSubmissionModal(true); }}
              >
                Submit Anyway
              </DarkGreenColorButton>
            </Grid>
          </Grid>
        </Grid>
        }
      />
      <CustomModal
        open={testSubmissionModal}
        setOpen={setTestSubmissionModal}
        divider={false}
        header={false}
        modalTitle={""}
        width={window.innerWidth > 600 ? "25%" : "95%"}
        modalContent={<Grid
          item
          container
          flexDirection={"column"}
          justifyContent={"center"}
          alignItems={"center"}
        >
          <CiCircleQuestion color={"#12A59B"} size={100} />
          <h5 className="poppinsRegular text-black pt-3 text-center">Confirm Test Submission</h5>
          <Grid item lg={12} sm={12} md={12} xs={12} className="pt-3" container flexDirection={"column"}>
            <p className="poppinsRegular text-black text-left pb-3">You are about to submit your test. Please ensure:</p>
            <ul>
              <li className="poppinsRegular text-black text-left pb-3">All questions have been answered to the best of your ability.</li>
              <li className="poppinsRegular text-black text-left pb-3">You are satisfied with your answers, as no changes can be made after submission.</li>
            </ul>
          </Grid>
          <Grid item container display={"flex"} justifyContent={"space-between"} sx={{ marginTop: "6%" }}>
            <Grid item container lg={5.8}>
              <PrimeGrayBorderColorButton
                className="px-3 py-2 w-100"
                onClick={() => setTestSubmissionModal(false)}
              >
                No
              </PrimeGrayBorderColorButton>
            </Grid>
            <Grid item container lg={5.8}>
              <DarkGreenColorButton
                className="px-3 py-2 w-100"
                onClick={() => { SubmitQuestions()  }}
              >
                Submit Test
              </DarkGreenColorButton>
            </Grid>
          </Grid>
        </Grid>
        }
      />
      <CustomModal
        open={successModal}
        setOpen={setSuccessModal}
        divider={false}
        header={false}
        modalTitle={""}
        width={window.innerWidth > 600 ? "25%" : "95%"}
        modalContent={
          <Grid
            item
            container
            flexDirection={"column"}
            justifyContent={"center"}
            alignItems={"center"}
          >
            <CiCircleCheck color={"#12A59B"} size={80} />
            <p className=" poppinsRegular Text-Prime-Black pt-3 text-center">Your submission has been successfully completed.</p>
            <Grid item container display={"flex"} justifyContent={"center"} sx={{ marginTop: "6%" }}>
              <GreenColorButton
                type="submit"
                className="px-3 py-2"
                onClick={() => HandleSuccessModal()}
              >
                Ok
              </GreenColorButton>
            </Grid>
          </Grid>
        }
      />
      <LoaderModal ShowLoader={ShowLoader} setShowLoader={setShowLoader} />
    </Grid>
  );
};

export default CBTComponent;
